import { AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY, DATAFLOW_READY_FOR_PRODUCTION, DATAFLOW_NON_READY_FOR_PRODUCTION } from "../../../utils/annotations";
import { getStringFromArtefactTriplet } from "../../../utils/sdmxJson";


export function getLinkedDataflowSource(node, dataflow, dataflowTriplet) {

  const linkedInfo = {
    endpointId: null, 
    dfId: null
  }

  const linkedAnnotationType = (node.annotations[AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY].type || "").toLowerCase();
  let linkedDataflowAnnotation = null;
  if (dataflow) {
    linkedDataflowAnnotation = (dataflow.annotations || []).find((ann) => (ann && (ann.type || "").toLowerCase()) === linkedAnnotationType);
    if (!linkedDataflowAnnotation) {
      linkedDataflowAnnotation = (dataflow.autoAnnotations || []).find((ann) => (ann && (ann.type || "").toLowerCase()) === linkedAnnotationType);
    }
  }
 
  const sourceEndpointId = linkedDataflowAnnotation 
    ? (linkedDataflowAnnotation.title || "").length > 0 ? linkedDataflowAnnotation.title : null
    : null; 
    
  const sourceDataflowId = linkedDataflowAnnotation 
    ? linkedDataflowAnnotation.text 
      ? linkedDataflowAnnotation.text["en"] 
      : dataflowTriplet ? getStringFromArtefactTriplet(dataflowTriplet) : null
    : null;

    linkedInfo.endpointId = sourceEndpointId;
    linkedInfo.dfId = sourceDataflowId;

  return linkedInfo;
  
}

export function hasMappingSetAssociated(nodes, nodeId, dataflows, dataflowTriplet){
  const node = nodes.find(node => node.general.id === nodeId);
  const dataflow = dataflows.filter(df => df.id === dataflowTriplet.id && df.agencyID === dataflowTriplet.agencyID && df.version === dataflowTriplet.version)[0];
  const readyForProductionAnnotationType = (node.annotations[DATAFLOW_READY_FOR_PRODUCTION].type || "").toLowerCase();
  const nonReadyForProductionAnnotationType = (node.annotations[DATAFLOW_NON_READY_FOR_PRODUCTION].type || "").toLowerCase()
  if (dataflow) {
    return (dataflow.annotations || []).find((ann) => ann && (((ann.type || "").toLowerCase()) === readyForProductionAnnotationType || ((ann.type || "").toLowerCase()) === nonReadyForProductionAnnotationType));
  }
  return false;
}

export function setLinkedDataflowAnnotationText(linkedDataflowNodeAnnotationType, dataflow, dataflowTriplet) {

  let linkedDataflowAnnotation = (dataflow.autoAnnotations || [])
    .find((ann) => ( ann && (ann.type || "").toLowerCase() === linkedDataflowNodeAnnotationType.toLowerCase()));

  const text = dataflowTriplet 
    ? {
        "en" : getStringFromArtefactTriplet(dataflowTriplet)
      }
    : null;
  if (linkedDataflowAnnotation) {
    linkedDataflowAnnotation.type = linkedDataflowNodeAnnotationType;
    linkedDataflowAnnotation.id = linkedDataflowNodeAnnotationType;
    linkedDataflowAnnotation.text = text;
  } else {
    linkedDataflowAnnotation = {
      type: linkedDataflowNodeAnnotationType,
      id: linkedDataflowNodeAnnotationType,
      text: text,
    };
  }

  const autoAnnotations = (dataflow.autoAnnotations || [])
      .filter((ann) => ( ann && (ann.type || "").toLowerCase() !== linkedDataflowNodeAnnotationType.toLowerCase()));
      
  autoAnnotations.push(linkedDataflowAnnotation);

  return autoAnnotations;
}

export function setLinkedDataflowAnnotationTitle(linkedDataflowNodeAnnotationType, dataflow, endpointId) {

  let linkedDataflowAnnotation = (dataflow.autoAnnotations || [])
    .find((ann) => ( ann && (ann.type || "").toLowerCase() === linkedDataflowNodeAnnotationType.toLowerCase()));
      if (linkedDataflowAnnotation) {
        linkedDataflowAnnotation.type = linkedDataflowNodeAnnotationType;
        linkedDataflowAnnotation.id = linkedDataflowNodeAnnotationType;
        linkedDataflowAnnotation.title = endpointId;
        linkedDataflowAnnotation.text = null;
      }
      else {
        linkedDataflowAnnotation = 
        {
          type: linkedDataflowNodeAnnotationType,
          id: linkedDataflowNodeAnnotationType,
          title: endpointId,
          text: null
        }
      }

    const autoAnnotations = (dataflow.autoAnnotations || [])
      .filter((ann) => (ann && (ann.type || "").toLowerCase() !== linkedDataflowNodeAnnotationType));
      
    autoAnnotations.push(linkedDataflowAnnotation);

    return autoAnnotations;
}

